import { render, staticRenderFns } from "./extraServiceRequest.vue?vue&type=template&id=2b38940b&"
import script from "@/scripts/extraServiceRequest/extraServiceRequest.js?vue&type=script&lang=js&"
export * from "@/scripts/extraServiceRequest/extraServiceRequest.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports